import React, {Component} from 'react'
import ReturnItem from "./ReturnItem.jsx"

class ReturnStep1 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      order: props.order,
    }
    this.updateOrder.bind(this)
  }

  updateOrder = (order) => {
    this.setState({ order, })
    this.props.updateOrder(order)
  }
  render() {
    return (
      <div className='text-xs'>
        <div className='flex items-center justify-between mb-7.5'>
          <div>
            {window.accountStrings.order.order} #: <span>{ this.state.order?.name?.replace('#', '') }</span>
          </div>
          <div>
            {window.accountStrings.order.date}: <span>{ this.state.order?.created_at || this.state.order?.createdAt?.split('T')[0] }</span>
          </div>
        </div>
        <div>
          <div className='mb-7.5'>
            {window.accountStrings.order.selectItems}
          </div>
          <div className='flex flex-col gap-8'>
            {
              this.state.order.line_items.filter(item => item.currentQuantity > 0 && item.refundableQuantity > 0)
                .map((item, index) =>
                  <ReturnItem key={`return-item-${index}`} 
                    order={this.state.order} 
                    item={item} 
                    updateOrder={this.updateOrder}
                  />
                )
            }
          </div>
        </div>
      </div>
    )
  }
}

export default ReturnStep1